export default (props) => (
  /**
   * Icone de uma etiqueta,
   * utilizado no menu de açoes
   * para abrir a parte de metadados.
   */
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.218 6.39079L6.96969 1.11249C6.81974 0.962541 6.60981 0.84258 6.36989 0.84258L1.42148 0.572667C0.911647 0.542677 0.491782 0.932551 0.461792 1.4124C0.461792 1.44239 0.461792 1.47238 0.461792 1.53236L0.761695 6.45077C0.761695 6.6607 0.881657 6.87064 1.03161 7.02059L6.24992 12.2989C6.42987 12.4788 6.6398 12.5688 6.87972 12.5688C7.11964 12.5688 7.35957 12.4788 7.50952 12.2989L12.188 7.65038C12.5479 7.2905 12.5479 6.75067 12.218 6.39079ZM5.50017 5.61104C5.02032 6.09089 4.27056 6.09089 3.79072 5.61104C3.31087 5.1312 3.31087 4.38144 3.79072 3.90159C4.27056 3.42175 5.02032 3.42175 5.50017 3.90159C5.98001 4.38144 5.98001 5.16119 5.50017 5.61104Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
  </svg>
);
